import { SimpleTooltip } from '../simple-tooltip';
import G17EcoLogo from '@g17eco/images/g17eco-icon.svg';

export const StaffIcon = () => (
  <SimpleTooltip text={'Support user'}>
    <img src={G17EcoLogo} alt='staff-icon' height={12} className='ml-2' />
  </SimpleTooltip>
);
